import { render, staticRenderFns } from "./Stripe.vue?vue&type=template&id=0a08aaea&scoped=true&"
import script from "./Stripe.vue?vue&type=script&lang=js&"
export * from "./Stripe.vue?vue&type=script&lang=js&"
import style0 from "./Stripe.vue?vue&type=style&index=0&id=0a08aaea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a08aaea",
  null
  
)

export default component.exports